export const config = {
  apiBase: import.meta.env.VITE_API_BASE || '/api',
  siteUrl: 'https://outlive.it'
};
